import { render, staticRenderFns } from "./Instances.vue?vue&type=template&id=18107811&scoped=true"
import script from "./Instances.vue?vue&type=script&lang=js"
export * from "./Instances.vue?vue&type=script&lang=js"
import style0 from "./Instances.vue?vue&type=style&index=0&id=18107811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18107811",
  null
  
)

export default component.exports